import axios from "axios";
import _axios from "../api";

export const getUserList = async (userType, qry) =>
  await _axios.get(`/admin/${userType}/list/${qry}`).then((response) => {
    return response.data;
  });

export const getAuthorityUserList = async (qry) =>
  await _axios.get(`/authority/User/${qry}`).then((response) => {
    return response.data;
  });

export const deleteUsers = async (id, value) =>
  await _axios.post(`/admin/delete/${id}/${value}`).then((response) => {
    return response.data;
  });

export const isActiveAuthority = async (id, value) =>
  await _axios.post(`/admin/isactive/${id}/${value}`).then((response) => {
    return response.data;
  });

export const addUser = async (webUserModel) =>
  await _axios.post(`/admin/add`, JSON.stringify(webUserModel)).then((response) => {
    return response.data;
  });

export const getIndividualUser = async (id) =>
  await _axios.get(`/admin/edit/${id}`).then((response) => {
    return response.data;
  });

export const updateUser = async (webUserModel) =>
  await _axios.post(`/admin/update`, JSON.stringify(webUserModel)).then((response) => {
    return response.data;
  });

export const modeUsers = async (theme) =>
  await _axios.post(`/mode/${theme}`).then((response) => {
    return response.data;
  });

export const getPostCodeList = async (obj) => {
  try {
    const response = await axios.get(
      `https://in8it.com/WebService/GetPostcodeList?postCode=${obj.postCode}&access_code=dNK8J34Kmn7geUj`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching postcode list:", error);
    throw error;
  }
};
